export const optimizerListAll = {
    "responseCode": {
        "code": 103,
        "status": "Success",
        "desc": "Recommendation List Fetched Successfully"
    },
    "responseList": {
        "generativeAI": {
            "totalCampaign": 2,
            "id": 4,
            "type": [
                {
                    "key": "keyword",
                    "value": "2",
                    "id": 8
                }
            ]
        },
        "blacklisting": {
            "totalCampaign": 7,
            "id": 2,
            "type": [
                {
                    "key": "keyword",
                    "value": "30",
                    "id": 8
                },
                {
                    "key": "creatives",
                    "value": "2",
                    "id": 3
                },
                {
                    "key": "domain",
                    "value": "8",
                    "id": 5
                },
                {
                    "key": "device",
                    "value": "1",
                    "id": 4
                },
                {
                    "key": "gender",
                    "value": "1",
                    "id": 6
                },
                {
                    "key": "age",
                    "value": "1",
                    "id": 0
                }
            ]
        },
        "budgetOptimisation": {
            "totalCampaign": 2,
            "id": 3,
            "type": [
                {
                    "key": "budget",
                    "value": "2",
                    "id": 2
                }
            ]
        },
        "bidControl": {
            "totalCampaign": 7,
            "id": 1,
            "type": [
                {
                    "key": "geo",
                    "value": "30",
                    "id": 7
                },
                {
                    "key": "device",
                    "value": "30",
                    "id": 4
                },
                {
                    "key": "age",
                    "value": "17",
                    "id": 0
                }
            ]
        }
    }
}

export const blacklistWhitlelisting = {
    "responseCode": {
        "code": 104,
        "status": "Success",
        "desc": "Fetched Recommendation List By Type and Subtype"
    },
    "responseList": {
        "blackListing": {
            "keyword": [
                {
                  id: '229',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Atualizações WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 229,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Atualizações WordPress'
                },
                {
                  id: '230',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Como recuperar site WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 230,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Como recuperar site WordPress'
                },
                {
                  id: '231',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Otimização de Site WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 231,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Otimização de Site WordPress'
                },
                {
                  id: '236',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'assessoria wordpress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 236,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'assessoria wordpress'
                },
                {
                  id: '248',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'WP Maintenance mode',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 248,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'WP Maintenance mode'
                },
                {
                  id: '251',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Atualizações WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 251,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Atualizações WordPress'
                },
                {
                  id: '252',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Como recuperar site WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 252,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Como recuperar site WordPress'
                },
                {
                  id: '276',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'WP Maintenance mode',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 276,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'WP Maintenance mode'
                },
                {
                  id: '279',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Atualizações WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 279,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Atualizações WordPress'
                },
                {
                  id: '280',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Como recuperar site WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 280,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Como recuperar site WordPress'
                },
                {
                  id: '294',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Otimização de Site WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 294,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Otimização de Site WordPress'
                },
                {
                  id: '295',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'WP Maintenance mode',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 295,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'WP Maintenance mode'
                },
                {
                  id: '296',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'assessoria wordpress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 296,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'assessoria wordpress'
                },
                {
                  id: '303',
                  platformName: 'Google Ads',
                  adGroupId: '170243766194',
                  keywordName: 'karjat luxury villas',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 303,
                  bekiCampId: 1650,
                  platCampaignId: '21676787196',
                  platStrategyId: '170243766194',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'karjat luxury villas'
                },
                {
                  id: '304',
                  platformName: 'Google Ads',
                  adGroupId: '170243766194',
                  keywordName: 'villas near mumbai for sale',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '26.705518701921577',
                  trId: 304,
                  bekiCampId: 1650,
                  platCampaignId: '21676787196',
                  platStrategyId: '170243766194',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'villas near mumbai for sale'
                },
                {
                  id: '317',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Otimização de Site WordPress',
                  campaignInfo: 'Customer Engagement - Holiday Campaign',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 317,
                  bekiCampId: 1550,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Otimização de Site WordPress'
                },
                {
                  id: '318',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'WP Maintenance mode',
                  campaignInfo: 'Customer Engagement - Holiday Campaign',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 318,
                  bekiCampId: 1550,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'WP Maintenance mode'
                },
                {
                  id: '319',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'assessoria wordpress',
                  campaignInfo: 'Customer Engagement - Holiday Campaign',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 319,
                  bekiCampId: 1550,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'assessoria wordpress'
                },
                {
                  id: '338',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Otimização de Site WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 338,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Otimização de Site WordPress'
                },
                {
                  id: '339',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'WP Maintenance mode',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 339,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'WP Maintenance mode'
                },
                {
                  id: '340',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'assessoria wordpress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 340,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'assessoria wordpress'
                },
                {
                  id: '360',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Otimização de Site WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 360,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Otimização de Site WordPress'
                },
                {
                  id: '361',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'WP Maintenance mode',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 361,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'WP Maintenance mode'
                },
                {
                  id: '362',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'assessoria wordpress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 362,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'assessoria wordpress'
                },
                {
                  id: '380',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Otimização de Site WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 380,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Otimização de Site WordPress'
                },
                {
                  id: '381',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'WP Maintenance mode',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 381,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'WP Maintenance mode'
                },
                {
                  id: '382',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'assessoria wordpress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 382,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'assessoria wordpress'
                },
                {
                  id: '400',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'Otimização de Site WordPress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 400,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'Otimização de Site WordPress'
                },
                {
                  id: '401',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'WP Maintenance mode',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 401,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'WP Maintenance mode'
                },
                {
                  id: '402',
                  platformName: 'Google Ads',
                  adGroupId: '163761217403',
                  keywordName: 'assessoria wordpress',
                  campaignInfo: 'Audience Awareness - New Year Teaser',
                  recommendation: 'Blacklisting_keyword',
                  subTypeId: '8',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  expectedOutcome: '0',
                  trId: 402,
                  bekiCampId: 1552,
                  platCampaignId: '21433541896',
                  platStrategyId: '163761217403',
                  type: 'Keyword',
                  subType: 'Blacklisting',
                  recoValue: 'assessoria wordpress'
                }
              ],
            "creatives": [
                {
                    "id": "263",
                    "platformName": "Google Ads",
                    "adGroupId": "156002202903",
                    "creativeId": "689407562070",
                    "campaignInfo": "Reach Skippable - Seasonal Offer",
                    "recommendation": "Blacklisting_creatives",
                    "subTypeId": "3",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "28.49959807799606",
                    "trId": 263,
                    "bekiCampId": 1549,
                    "platCampaignId": "20911727933",
                    "platStrategyId": "156002202903",
                    "type": "Creative",
                    "subType": "Blacklisting",
                    "recoValue": "Google_Display_2"
                },
                {
                    "id": "264",
                    "platformName": "Google Ads",
                    "adGroupId": "158945463752",
                    "creativeId": "689519182927",
                    "campaignInfo": "Reach Skippable - Seasonal Offer",
                    "recommendation": "Blacklisting_creatives",
                    "subTypeId": "3",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "6.829116945042732",
                    "trId": 264,
                    "bekiCampId": 1549,
                    "platCampaignId": "20911727933",
                    "platStrategyId": "158945463752",
                    "type": "Creative",
                    "subType": "Blacklisting",
                    "recoValue": "Google_Display_1"
                }
            ],
            "age": [
                {
                    "id": "50",
                    "platformName": "Meta",
                    "adSetId": "120207754459090374",
                    "age": "45-64",
                    "campaignInfo": "Customer Engagement - Holiday Campaign",
                    "recommendation": "Whitelisting_age",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "73.91182252011758",
                    "trId": 50,
                    "bekiCampId": 1543,
                    "platCampaignId": "120207754458900374",
                    "platStrategyId": "120207754459090374",
                    "type": "Age",
                    "subType": "Whitelisting",
                    "recoValue": "45-64"
                }
            ],
            "domain": [
                {
                    "id": "255",
                    "platformName": "Google Ads",
                    "adGroupId": "166618365098",
                    "domain": "techcoginfo.com",
                    "campaignInfo": "Brand Awareness - Festive Teaser",
                    "recommendation": "Blacklisting_domain",
                    "subTypeId": "5",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "0.9663434532052442",
                    "trId": 255,
                    "bekiCampId": 1627,
                    "platCampaignId": "21503954527",
                    "platStrategyId": "166618365098",
                    "type": "Domain",
                    "subType": "Blacklisting",
                    "recoValue": "techcoginfo.com"
                },
                {
                    "id": "256",
                    "platformName": "Dv360",
                    "lineItemId": "nan",
                    "domain": "Bubble Shooter Gem Puzzle Pop - Android (com.pop.bubbleshooter.gem.classic.games)",
                    "campaignInfo": "Customer Engagement - Holiday Campaign",
                    "recommendation": "Blacklisting_domain",
                    "subTypeId": "5",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "4.738274628493816",
                    "trId": 256,
                    "bekiCampId": 1536,
                    "platCampaignId": "54669631",
                    "platStrategyId": "nan",
                    "type": "Domain",
                    "subType": "Blacklisting",
                    "recoValue": "Bubble Shooter Gem Puzzle Pop - Android (com.pop.bubbleshooter.gem.classic.games)"
                },
                {
                    "id": "257",
                    "platformName": "Dv360",
                    "lineItemId": "nan",
                    "domain": "Downloader - Free Video Downloader App - Android (downloader.vitmate.downloaderapp)",
                    "campaignInfo": "Customer Engagement - Holiday Campaign",
                    "recommendation": "Blacklisting_domain",
                    "subTypeId": "5",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "2.634632557791336",
                    "trId": 257,
                    "bekiCampId": 1536,
                    "platCampaignId": "54669631",
                    "platStrategyId": "nan",
                    "type": "Domain",
                    "subType": "Blacklisting",
                    "recoValue": "Downloader - Free Video Downloader App - Android (downloader.vitmate.downloaderapp)"
                },
                {
                    "id": "258",
                    "platformName": "Dv360",
                    "lineItemId": "nan",
                    "domain": "Bricks Breaker Quest - Android (com.mobirix.swipebrick2)",
                    "campaignInfo": "Customer Engagement - Holiday Campaign",
                    "recommendation": "Blacklisting_domain",
                    "subTypeId": "5",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "2.594527536107888",
                    "trId": 258,
                    "bekiCampId": 1536,
                    "platCampaignId": "54669631",
                    "platStrategyId": "nan",
                    "type": "Domain",
                    "subType": "Blacklisting",
                    "recoValue": "Bricks Breaker Quest - Android (com.mobirix.swipebrick2)"
                },
                {
                    "id": "259",
                    "platformName": "Google Ads",
                    "adGroupId": "165225828876",
                    "domain": "horoscopovirtual.com.br",
                    "campaignInfo": "Brand Awareness - Festive Teaser",
                    "recommendation": "Blacklisting_domain",
                    "subTypeId": "5",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "0",
                    "trId": 259,
                    "bekiCampId": 1627,
                    "platCampaignId": "21503954527",
                    "platStrategyId": "165225828876",
                    "type": "Domain",
                    "subType": "Blacklisting",
                    "recoValue": "horoscopovirtual.com.br"
                },
                {
                    "id": "260",
                    "platformName": "Google Ads",
                    "adGroupId": "165225828876",
                    "domain": "simpatiasonline.net",
                    "campaignInfo": "Brand Awareness - Festive Teaser",
                    "recommendation": "Blacklisting_domain",
                    "subTypeId": "5",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "0",
                    "trId": 260,
                    "bekiCampId": 1627,
                    "platCampaignId": "21503954527",
                    "platStrategyId": "165225828876",
                    "type": "Domain",
                    "subType": "Blacklisting",
                    "recoValue": "simpatiasonline.net"
                },
                {
                    "id": "261",
                    "platformName": "Google Ads",
                    "adGroupId": "165225828876",
                    "domain": "sportlife.com.br",
                    "campaignInfo": "Brand Awareness - Festive Teaser",
                    "recommendation": "Blacklisting_domain",
                    "subTypeId": "5",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "0",
                    "trId": 261,
                    "bekiCampId": 1627,
                    "platCampaignId": "21503954527",
                    "platStrategyId": "165225828876",
                    "type": "Domain",
                    "subType": "Blacklisting",
                    "recoValue": "sportlife.com.br"
                },
                {
                    "id": "262",
                    "platformName": "Google Ads",
                    "adGroupId": "166618365098",
                    "domain": "curapelanatureza.com.br",
                    "campaignInfo": "Brand Awareness - Festive Teaser",
                    "recommendation": "Blacklisting_domain",
                    "subTypeId": "5",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "0",
                    "trId": 262,
                    "bekiCampId": 1627,
                    "platCampaignId": "21503954527",
                    "platStrategyId": "166618365098",
                    "type": "Domain",
                    "subType": "Blacklisting",
                    "recoValue": "curapelanatureza.com.br"
                }
            ],
            "gender": [
                {
                    "id": "53",
                    "platformName": "Meta",
                    "adSetId": "120207754459090374",
                    "gender": "male",
                    "campaignInfo": "Customer Engagement - Holiday Campaign",
                    "recommendation": "Whitelisting_gender",
                    "subTypeId": "6",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "25.451083631010434",
                    "trId": 53,
                    "bekiCampId": 1543,
                    "platCampaignId": "120207754458900374",
                    "platStrategyId": "120207754459090374",
                    "type": "Gender",
                    "subType": "Whitelisting",
                    "recoValue": "male"
                }
            ],
            "device": [
                {
                    "id": "52",
                    "platformName": "Meta",
                    "adSetId": "120207754459090374",
                    "device": "mobile_web",
                    "campaignInfo": "Customer Engagement - Holiday Campaign",
                    "recommendation": "Whitelisting_devices",
                    "subTypeId": "4",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "expectedOutcome": "5.580689898387835",
                    "trId": 52,
                    "bekiCampId": 1543,
                    "platCampaignId": "120207754458900374",
                    "platStrategyId": "120207754459090374",
                    "type": "Device",
                    "subType": "Whitelisting",
                    "recoValue": "mobile_web"
                }
            ]
        }
    }
}

export const generativeAI = {
    "responseCode": {
        "code": 104,
        "status": "Success",
        "desc": "Fetched Recommendation List By Type and Subtype"
    },
    "responseList": {
        "generativeAI": {
            "keyword": [
                {
                    "id": "562",
                    "platformName": "Google Ads",
                    "adGroupId": "120208683901465565",
                    "campaignInfo": "Reach Skippable - Seasonal Offer",
                    "recommendation": "genAI",
                    "subTypeId": "8",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 562,
                    "bekiCampId": 1549,
                    "platCampaignId": "120208683901399999",
                    "platStrategyId": "120208683901465565",
                    "type": "Keyword",
                    "subType": "Suggestion",
                    "recoValue": "genAI",
                    "recoInfo": "genAI"
                },
                {
                    "id": "563",
                    "platformName": "Google Ads",
                    "adGroupId": "120208683901390374",
                    "campaignInfo": "Customer Engagement - Holiday Campaign",
                    "recommendation": "openAI",
                    "subTypeId": "8",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 563,
                    "bekiCampId": 1543,
                    "platCampaignId": "120208683901390374",
                    "platStrategyId": "120208683901390374",
                    "type": "Keyword",
                    "subType": "Suggestion",
                    "recoValue": "openAI",
                    "recoInfo": "openAI"
                }
            ]
        }
    }
}

export const budgetOptimisation = {
    "responseCode": {
        "code": 104,
        "status": "Success",
        "desc": "Fetched Recommendation List By Type and Subtype"
    },
    "responseList": {
        "budgetOptimisation": {
            "budgetAllocation": [
                {
                    "id": "560",
                    "platformName": "Meta",
                    "adSetId": "120208683901390374",
                    "oldBudget": "80.0",
                    "allocatedBudget": "100.0",
                    "platformOldBudget": "80.0",
                    "platformAllocatedBudget": "100.0",
                    "campaignInfo": "Customer Engagement - Holiday Campaign",
                    "recommendation": "Budget_Reallocation",
                    "subTypeId": "2",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "currency": "INR",
                    "trId": 560,
                    "bekiCampId": 1543,
                    "platCampaignId": "120208683901390374",
                    "platStrategyId": "120208683901390374",
                    "type": "Budget",
                    "subType": "Reallocation",
                    "recoValue": "250",
                    "recoInfo": "200",
                    "bekiRecoValueBudget": "100.0",
                    "bekiRecoInfoBudget": "80.0"
                },
                {
                    "id": "561",
                    "platformName": "Meta",
                    "adSetId": "120208683901465565",
                    "oldBudget": "80.0",
                    "allocatedBudget": "100.0",
                    "platformOldBudget": "80.0",
                    "platformAllocatedBudget": "100.0",
                    "campaignInfo": "Reach Skippable - Seasonal Offer",
                    "recommendation": "Budget_Reallocation",
                    "subTypeId": "2",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "currency": "INR",
                    "trId": 561,
                    "bekiCampId": 1549,
                    "platCampaignId": "120208683901399999",
                    "platStrategyId": "120208683901465565",
                    "type": "Budget",
                    "subType": "Reallocation",
                    "recoValue": "150",
                    "recoInfo": "200",
                    "bekiRecoValueBudget": "80.0",
                    "bekiRecoInfoBudget": "100.0"
                }
            ]
        }
    }
}

export const bidControl = {
    "responseCode": {
        "code": 104,
        "status": "Success",
        "desc": "Fetched Recommendation List By Type and Subtype"
    },
    "responseList": {
        "bidControl": {
            "age": [
                {
                    "id": "298",
                    "platformName": "Google Ads",
                    "adGroupId": "170243766194",
                    "age": "35-44",
                    "campaignInfo": "Truview Skippable - Product Launch",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 298,
                    "bekiCampId": 1650,
                    "platCampaignId": "21676787196",
                    "platStrategyId": "170243766194",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_35_44"
                },
                {
                    "id": "308",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659119",
                    "age": "25-34",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 308,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659119",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_25_34"
                },
                {
                    "id": "310",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659279",
                    "age": "45-54",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 310,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659279",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_45_54"
                },
                {
                    "id": "311",
                    "platformName": "Google Ads",
                    "adGroupId": "170243766194",
                    "age": "35-44",
                    "campaignInfo": "Truview Skippable - Product Launch",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 311,
                    "bekiCampId": 1650,
                    "platCampaignId": "21676787196",
                    "platStrategyId": "170243766194",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_35_44"
                },
                {
                    "id": "327",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659279",
                    "age": "18-24",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 327,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659279",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_18_24"
                },
                {
                    "id": "328",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659279",
                    "age": "25-34",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 328,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659279",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_25_34"
                },
                {
                    "id": "331",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659119",
                    "age": "35-44",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "-0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 331,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659119",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "-0.1",
                    "recoInfo": "AGE_RANGE_35_44"
                },
                {
                    "id": "332",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659279",
                    "age": "35-44",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 332,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659279",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_35_44"
                },
                {
                    "id": "333",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659119",
                    "age": "35-44",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 333,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659119",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_35_44"
                },
                {
                    "id": "351",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659119",
                    "age": "45-54",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "-0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 351,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659119",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "-0.1",
                    "recoInfo": "AGE_RANGE_45_54"
                },
                {
                    "id": "354",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659279",
                    "age": "25-34",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 354,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659279",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_25_34"
                },
                {
                    "id": "372",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659119",
                    "age": "45-54",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "-0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 372,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659119",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "-0.1",
                    "recoInfo": "AGE_RANGE_45_54"
                },
                {
                    "id": "374",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659279",
                    "age": "25-34",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 374,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659279",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_25_34"
                },
                {
                    "id": "392",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659119",
                    "age": "45-54",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "-0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 392,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659119",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "-0.1",
                    "recoInfo": "AGE_RANGE_45_54"
                },
                {
                    "id": "394",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659279",
                    "age": "25-34",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 394,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659279",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_25_34"
                },
                {
                    "id": "415",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659119",
                    "age": "45-54",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "-0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 415,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659119",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "-0.1",
                    "recoInfo": "AGE_RANGE_45_54"
                },
                {
                    "id": "417",
                    "platformName": "Google Ads",
                    "adGroupId": "146455659279",
                    "age": "25-34",
                    "campaignInfo": "Website Traffic - Winter Sale",
                    "recommendation": "Bid Control_age",
                    "bidModification": "0.1",
                    "subTypeId": "0",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-30 05:16:20",
                    "trId": 417,
                    "bekiCampId": 1943,
                    "platCampaignId": "19855040852",
                    "platStrategyId": "146455659279",
                    "type": "Age",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.1",
                    "recoInfo": "AGE_RANGE_25_34"
                }
            ],
            "geo": [
                {
                    id: '194',
                    platformName: 'Google Ads',
                    adGroupId: '133740171073',
                    geo: 'Brazil,State of Sao Paulo,Sao Paulo',
                    campaignInfo: 'Truview Skippable - Product Launch',
                    recommendation: 'Bid Control_geo',
                    bidModification: '0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 194,
                    bekiCampId: 1548,
                    platCampaignId: '14250134598',
                    platStrategyId: '133740171073',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '0.10',
                    recoInfo: '1001773'
                },
                {
                    id: '195',
                    platformName: 'Google Ads',
                    adGroupId: '122627234581',
                    geo: 'Brazil,State of Sao Paulo,Campinas',
                    campaignInfo: 'Truview Skippable - Product Launch',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 195,
                    bekiCampId: 1548,
                    platCampaignId: '14250134598',
                    platStrategyId: '122627234581',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1001729'
                },
                {
                    id: '196',
                    platformName: 'Google Ads',
                    adGroupId: '122627234581',
                    geo: 'Brazil,State of Sao Paulo,Roseira',
                    campaignInfo: 'Truview Skippable - Product Launch',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 196,
                    bekiCampId: 1548,
                    platCampaignId: '14250134598',
                    platStrategyId: '122627234581',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '9074252'
                },
                {
                    id: '197',
                    platformName: 'Google Ads',
                    adGroupId: '156002202903',
                    geo: 'Brazil,State of Goias,Aguas Lindas de Goias',
                    campaignInfo: 'Reach Skippable - Seasonal Offer',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 197,
                    bekiCampId: 1549,
                    platCampaignId: '20911727933',
                    platStrategyId: '156002202903',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1032140'
                },
                {
                    id: '198',
                    platformName: 'Google Ads',
                    adGroupId: '156002202903',
                    geo: 'Brazil,State of Paraiba,Alagoa Grande',
                    campaignInfo: 'Reach Skippable - Seasonal Offer',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 198,
                    bekiCampId: 1549,
                    platCampaignId: '20911727933',
                    platStrategyId: '156002202903',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031414'
                },
                {
                    id: '199',
                    platformName: 'Google Ads',
                    adGroupId: '156002202903',
                    geo: 'Brazil,State of Bahia,Alagoinhas',
                    campaignInfo: 'Reach Skippable - Seasonal Offer',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 199,
                    bekiCampId: 1549,
                    platCampaignId: '20911727933',
                    platStrategyId: '156002202903',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1001516'
                },
                {
                    id: '200',
                    platformName: 'Google Ads',
                    adGroupId: '167884722609',
                    geo: 'Brazil,State of Ceara,Aracati',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 200,
                    bekiCampId: 1587,
                    platCampaignId: '21489818805',
                    platStrategyId: '167884722609',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031436'
                },
                {
                    id: '201',
                    platformName: 'Google Ads',
                    adGroupId: '167884722609',
                    geo: 'Brazil,State of Pernambuco,Araripina',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 201,
                    bekiCampId: 1587,
                    platCampaignId: '21489818805',
                    platStrategyId: '167884722609',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031445'
                },
                {
                    id: '202',
                    platformName: 'Google Ads',
                    adGroupId: '156002202903',
                    geo: 'Brazil,State of Para,Altamira',
                    campaignInfo: 'Reach Skippable - Seasonal Offer',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 202,
                    bekiCampId: 1549,
                    platCampaignId: '20911727933',
                    platStrategyId: '156002202903',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1001609'
                },
                {
                    id: '203',
                    platformName: 'Google Ads',
                    adGroupId: '167884722609',
                    geo: 'Brazil,State of Ceara,Aracati',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 203,
                    bekiCampId: 1587,
                    platCampaignId: '21489818805',
                    platStrategyId: '167884722609',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '9074137'
                },
                {
                    id: '204',
                    platformName: 'Google Ads',
                    adGroupId: '166618365098',
                    geo: 'Brazil,State of Sao Paulo,Sao Paulo',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 204,
                    bekiCampId: 1627,
                    platCampaignId: '21503954527',
                    platStrategyId: '166618365098',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '0.10',
                    recoInfo: '1001773'
                },
                {
                    id: '205',
                    platformName: 'Google Ads',
                    adGroupId: '165225828876',
                    geo: 'Brazil,State of Sao Paulo,Andradina',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 205,
                    bekiCampId: 1627,
                    platCampaignId: '21503954527',
                    platStrategyId: '165225828876',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031427'
                },
                {
                    id: '206',
                    platformName: 'Google Ads',
                    adGroupId: '165225828876',
                    geo: 'Brazil,State of Sao Paulo,Barueri',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 206,
                    bekiCampId: 1627,
                    platCampaignId: '21503954527',
                    platStrategyId: '165225828876',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1001724'
                },
                {
                    id: '212',
                    platformName: 'Google Ads',
                    adGroupId: '165225828876',
                    geo: 'Brazil,State of Sao Paulo,Bauru',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 212,
                    bekiCampId: 1627,
                    platCampaignId: '21503954527',
                    platStrategyId: '165225828876',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1001725'
                },
                {
                    id: '213',
                    platformName: 'Google Ads',
                    adGroupId: '167884722609',
                    geo: 'Brazil,State of Maranhao,Barra do Corda',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 213,
                    bekiCampId: 1587,
                    platCampaignId: '21489818805',
                    platStrategyId: '167884722609',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031472'
                },
                {
                    id: '214',
                    platformName: 'Google Ads',
                    adGroupId: '166618365098',
                    geo: 'Brazil,State of Sao Paulo,Jundiai',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 214,
                    bekiCampId: 1627,
                    platCampaignId: '21503954527',
                    platStrategyId: '166618365098',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '0.10',
                    recoInfo: '1001743'
                },
                {
                    id: '218',
                    platformName: 'Google Ads',
                    adGroupId: '133740171073',
                    geo: 'Brazil,State of Sao Paulo,Sao Paulo',
                    campaignInfo: 'Truview Skippable - Product Launch',
                    recommendation: 'Bid Control_geo',
                    bidModification: '0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 218,
                    bekiCampId: 1548,
                    platCampaignId: '14250134598',
                    platStrategyId: '133740171073',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '0.10',
                    recoInfo: '1001773'
                },
                {
                    id: '219',
                    platformName: 'Google Ads',
                    adGroupId: '122627234581',
                    geo: 'Brazil,State of Sao Paulo,Campinas',
                    campaignInfo: 'Truview Skippable - Product Launch',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 219,
                    bekiCampId: 1548,
                    platCampaignId: '14250134598',
                    platStrategyId: '122627234581',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1001729'
                },
                {
                    id: '220',
                    platformName: 'Google Ads',
                    adGroupId: '122627234581',
                    geo: 'Brazil,State of Sao Paulo,Roseira',
                    campaignInfo: 'Truview Skippable - Product Launch',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 220,
                    bekiCampId: 1548,
                    platCampaignId: '14250134598',
                    platStrategyId: '122627234581',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '9074252'
                },
                {
                    id: '221',
                    platformName: 'Google Ads',
                    adGroupId: '156002202903',
                    geo: 'Brazil,State of Goias,Aguas Lindas de Goias',
                    campaignInfo: 'Reach Skippable - Seasonal Offer',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 221,
                    bekiCampId: 1549,
                    platCampaignId: '20911727933',
                    platStrategyId: '156002202903',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1032140'
                },
                {
                    id: '222',
                    platformName: 'Google Ads',
                    adGroupId: '156002202903',
                    geo: 'Brazil,State of Paraiba,Alagoa Grande',
                    campaignInfo: 'Reach Skippable - Seasonal Offer',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 222,
                    bekiCampId: 1549,
                    platCampaignId: '20911727933',
                    platStrategyId: '156002202903',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031414'
                },
                {
                    id: '223',
                    platformName: 'Google Ads',
                    adGroupId: '156002202903',
                    geo: 'Brazil,State of Bahia,Alagoinhas',
                    campaignInfo: 'Reach Skippable - Seasonal Offer',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 223,
                    bekiCampId: 1549,
                    platCampaignId: '20911727933',
                    platStrategyId: '156002202903',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1001516'
                },
                {
                    id: '224',
                    platformName: 'Google Ads',
                    adGroupId: '167884722609',
                    geo: 'Brazil,State of Pernambuco,Araripina',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 224,
                    bekiCampId: 1587,
                    platCampaignId: '21489818805',
                    platStrategyId: '167884722609',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031445'
                },
                {
                    id: '225',
                    platformName: 'Google Ads',
                    adGroupId: '166618365098',
                    geo: 'Brazil,State of Sao Paulo,Itapecerica da Serra',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 225,
                    bekiCampId: 1627,
                    platCampaignId: '21503954527',
                    platStrategyId: '166618365098',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '0.10',
                    recoInfo: '1031711'
                },
                {
                    id: '226',
                    platformName: 'Google Ads',
                    adGroupId: '156002202903',
                    geo: 'Brazil,State of Maranhao,Acailandia',
                    campaignInfo: 'Reach Skippable - Seasonal Offer',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 226,
                    bekiCampId: 1549,
                    platCampaignId: '20911727933',
                    platStrategyId: '156002202903',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031463'
                },
                {
                    id: '227',
                    platformName: 'Google Ads',
                    adGroupId: '167884722609',
                    geo: 'Brazil,State of Ceara,Aracati',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 227,
                    bekiCampId: 1587,
                    platCampaignId: '21489818805',
                    platStrategyId: '167884722609',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031436'
                },
                {
                    id: '228',
                    platformName: 'Google Ads',
                    adGroupId: '165225828876',
                    geo: 'Brazil,State of Sao Paulo,Andradina',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 228,
                    bekiCampId: 1627,
                    platCampaignId: '21503954527',
                    platStrategyId: '165225828876',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031427'
                },
                {
                    id: '233',
                    platformName: 'Google Ads',
                    adGroupId: '167884722609',
                    geo: 'Brazil,State of Paraiba,Bayeux',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 233,
                    bekiCampId: 1587,
                    platCampaignId: '21489818805',
                    platStrategyId: '167884722609',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '9074272'
                },
                {
                    id: '234',
                    platformName: 'Google Ads',
                    adGroupId: '165225828876',
                    geo: 'Brazil,State of Sao Paulo,Avare',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 234,
                    bekiCampId: 1627,
                    platCampaignId: '21503954527',
                    platStrategyId: '165225828876',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '9074197'
                },
                {
                    id: '235',
                    platformName: 'Google Ads',
                    adGroupId: '167884722609',
                    geo: 'Brazil,State of Maranhao,Barra do Corda',
                    campaignInfo: 'Brand Awareness - Festive Teaser',
                    recommendation: 'Bid Control_geo',
                    bidModification: '-0.10',
                    subTypeId: '7',
                    tenantName: 'Demo Advertiser',
                    date: '2025-01-30 05:16:20',
                    trId: 235,
                    bekiCampId: 1587,
                    platCampaignId: '21489818805',
                    platStrategyId: '167884722609',
                    type: 'Geo',
                    subType: 'Bid Adjustment',
                    recoValue: '-0.10',
                    recoInfo: '1031472'
                }
            ],
            "device": [
                {
                  id: '189',
                  platformName: 'Google Ads',
                  adGroupId: '122627234581',
                  device: 'Desktop',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 189,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '122627234581',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '190',
                  platformName: 'Google Ads',
                  adGroupId: '125455513813',
                  device: 'Desktop',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 190,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '125455513813',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '191',
                  platformName: 'Google Ads',
                  adGroupId: '125455513813',
                  device: 'Mobile',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 191,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '125455513813',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'MOBILE'
                },
                {
                  id: '192',
                  platformName: 'Google Ads',
                  adGroupId: '156002202903',
                  device: 'Desktop',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 192,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '156002202903',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '193',
                  platformName: 'Google Ads',
                  adGroupId: '167884722609',
                  device: 'Mobile',
                  campaignInfo: 'Brand Awareness - Festive Teaser',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 193,
                  bekiCampId: 1587,
                  platCampaignId: '21489818805',
                  platStrategyId: '167884722609',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'MOBILE'
                },
                {
                  id: '210',
                  platformName: 'Google Ads',
                  adGroupId: '158945463752',
                  device: 'Desktop',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 210,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '158945463752',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '211',
                  platformName: 'Google Ads',
                  adGroupId: '165225828876',
                  device: 'Tablet',
                  campaignInfo: 'Brand Awareness - Festive Teaser',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 211,
                  bekiCampId: 1627,
                  platCampaignId: '21503954527',
                  platStrategyId: '165225828876',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'TABLET'
                },
                {
                  id: '215',
                  platformName: 'Google Ads',
                  adGroupId: '122627234581',
                  device: 'Desktop',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 215,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '122627234581',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '216',
                  platformName: 'Google Ads',
                  adGroupId: '125455513813',
                  device: 'Desktop',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 216,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '125455513813',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '217',
                  platformName: 'Google Ads',
                  adGroupId: '125455513813',
                  device: 'Mobile',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 217,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '125455513813',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'MOBILE'
                },
                {
                  id: '232',
                  platformName: 'Google Ads',
                  adGroupId: '156002202903',
                  device: 'Tablet',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 232,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '156002202903',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'TABLET'
                },
                {
                  id: '237',
                  platformName: 'Google Ads',
                  adGroupId: '122627234581',
                  device: 'Desktop',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 237,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '122627234581',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '238',
                  platformName: 'Google Ads',
                  adGroupId: '125455513813',
                  device: 'Desktop',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 238,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '125455513813',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '239',
                  platformName: 'Google Ads',
                  adGroupId: '125455513813',
                  device: 'Mobile',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 239,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '125455513813',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'MOBILE'
                },
                {
                  id: '240',
                  platformName: 'Google Ads',
                  adGroupId: '166618365098',
                  device: 'Desktop',
                  campaignInfo: 'Brand Awareness - Festive Teaser',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 240,
                  bekiCampId: 1627,
                  platCampaignId: '21503954527',
                  platStrategyId: '166618365098',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '253',
                  platformName: 'Google Ads',
                  adGroupId: '156002202903',
                  device: 'Tablet',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 253,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '156002202903',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'TABLET'
                },
                {
                  id: '254',
                  platformName: 'Google Ads',
                  adGroupId: '165225828876',
                  device: 'Tablet',
                  campaignInfo: 'Brand Awareness - Festive Teaser',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 254,
                  bekiCampId: 1627,
                  platCampaignId: '21503954527',
                  platStrategyId: '165225828876',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'TABLET'
                },
                {
                  id: '266',
                  platformName: 'Google Ads',
                  adGroupId: '122627234581',
                  device: 'Desktop',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 266,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '122627234581',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '267',
                  platformName: 'Google Ads',
                  adGroupId: '125455513813',
                  device: 'Desktop',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 267,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '125455513813',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '268',
                  platformName: 'Google Ads',
                  adGroupId: '125455513813',
                  device: 'Mobile',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 268,
                  bekiCampId: 1548,
                  platCampaignId: '14250134598',
                  platStrategyId: '125455513813',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'MOBILE'
                },
                {
                  id: '281',
                  platformName: 'Google Ads',
                  adGroupId: '170243766194',
                  device: 'Desktop',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 281,
                  bekiCampId: 1650,
                  platCampaignId: '21676787196',
                  platStrategyId: '170243766194',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '282',
                  platformName: 'Google Ads',
                  adGroupId: '156002202903',
                  device: 'Desktop',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 282,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '156002202903',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '283',
                  platformName: 'Google Ads',
                  adGroupId: '156002202903',
                  device: 'Mobile',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 283,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '156002202903',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'MOBILE'
                },
                {
                  id: '284',
                  platformName: 'Google Ads',
                  adGroupId: '158945463752',
                  device: 'Desktop',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 284,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '158945463752',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '306',
                  platformName: 'Google Ads',
                  adGroupId: '167599620626',
                  device: 'Mobile',
                  campaignInfo: 'Truview Skippable - Product Launch',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 306,
                  bekiCampId: 1940,
                  platCampaignId: '21760639117',
                  platStrategyId: '167599620626',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'MOBILE'
                },
                {
                  id: '312',
                  platformName: 'Google Ads',
                  adGroupId: '156002202903',
                  device: 'Desktop',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 312,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '156002202903',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '313',
                  platformName: 'Google Ads',
                  adGroupId: '158945463752',
                  device: 'Mobile',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 313,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '158945463752',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'MOBILE'
                },
                {
                  id: '324',
                  platformName: 'Google Ads',
                  adGroupId: '146455659119',
                  device: 'Tablet',
                  campaignInfo: 'Website Traffic - Winter Sale',
                  recommendation: 'Bid Control_devices',
                  bidModification: '-0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 324,
                  bekiCampId: 1943,
                  platCampaignId: '19855040852',
                  platStrategyId: '146455659119',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '-0.10',
                  recoInfo: 'TABLET'
                },
                {
                  id: '334',
                  platformName: 'Google Ads',
                  adGroupId: '156002202903',
                  device: 'Desktop',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 334,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '156002202903',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'DESKTOP'
                },
                {
                  id: '335',
                  platformName: 'Google Ads',
                  adGroupId: '158945463752',
                  device: 'Mobile',
                  campaignInfo: 'Reach Skippable - Seasonal Offer',
                  recommendation: 'Bid Control_devices',
                  bidModification: '0.10',
                  subTypeId: '4',
                  tenantName: 'Demo Advertiser',
                  date: '2025-01-30 05:16:20',
                  trId: 335,
                  bekiCampId: 1549,
                  platCampaignId: '20911727933',
                  platStrategyId: '158945463752',
                  type: 'Device',
                  subType: 'Bid Adjustment',
                  recoValue: '0.10',
                  recoInfo: 'MOBILE'
                }
              ]
        }
    }
}

export const samplePopup = {
    "responseCode": {
        "code": 104,
        "status": "Success",
        "desc": "Fetched Recommendation List By Type and Subtype"
    },
    "responseList": {
        "bidControl": {
            "geo": [
                {
                    "id": "194",
                    "platformName": "Google Ads",
                    "adGroupId": "133740171073",
                    "geo": "Brazil,State of Sao Paulo,Sao Paulo",
                    "campaignInfo": "Truview Skippable - Product Launch",
                    "recommendation": "Bid Control_geo",
                    "bidModification": "0.10",
                    "subTypeId": "7",
                    "tenantName": "Demo Advertiser",
                    "date": "2025-01-28 20:16:07",
                    "trId": 194,
                    "bekiCampId": 1548,
                    "platCampaignId": "14250134598",
                    "platStrategyId": "133740171073",
                    "type": "Geo",
                    "subType": "Bid Adjustment",
                    "recoValue": "0.10",
                    "recoInfo": "1001773"
                }
            ]
        }
    }
}

export const totalRecommenationList = {
    "responseCode": {
        "code": 102,
        "status": "Success",
        "desc": "Recommendation History List Fetched Successfully"
    },
    "responseList": {
        "recommendationList": [
            {
                "id": "50",
                "platformName": "Meta",
                "adSetId": "120207754459090374",
                "newValue": "45-64",
                "status": "0",
                "campaignInfo": "Customer Engagement - Holiday Campaign",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Whitelisting_age",
                "tenantName": "Demo Advertiser",
                "trId": 50,
                "bekiCampId": 1543
            },
            {
                "id": "51",
                "platformName": "Meta",
                "adSetId": "120207754459090374",
                "newValue": "mobile_app",
                "status": "3",
                "campaignInfo": "Customer Engagement - Holiday Campaign",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Whitelisting_devices",
                "tenantName": "Demo Advertiser",
                "trId": 51,
                "bekiCampId": 1543
            },
            {
                "id": "52",
                "platformName": "Meta",
                "adSetId": "120207754459090374",
                "newValue": "mobile_web",
                "status": "0",
                "campaignInfo": "Customer Engagement - Holiday Campaign",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Whitelisting_devices",
                "tenantName": "Demo Advertiser",
                "trId": 52,
                "bekiCampId": 1543
            },
            {
                "id": "53",
                "platformName": "Meta",
                "adSetId": "120207754459090374",
                "newValue": "male",
                "status": "0",
                "campaignInfo": "Customer Engagement - Holiday Campaign",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Whitelisting_gender",
                "tenantName": "Demo Advertiser",
                "trId": 53,
                "bekiCampId": 1543
            },
            {
                "id": "60",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "704528268419",
                "status": "2",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_creatives",
                "tenantName": "Demo Advertiser",
                "trId": 60,
                "bekiCampId": 1552
            },
            {
                "id": "259",
                "platformName": "Google Ads",
                "adSetId": "165225828876",
                "newValue": "horoscopovirtual.com.br",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_domain",
                "tenantName": "Demo Advertiser",
                "trId": 259,
                "bekiCampId": 1627
            },
            {
                "id": "260",
                "platformName": "Google Ads",
                "adSetId": "165225828876",
                "newValue": "simpatiasonline.net",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_domain",
                "tenantName": "Demo Advertiser",
                "trId": 260,
                "bekiCampId": 1627
            },
            {
                "id": "261",
                "platformName": "Google Ads",
                "adSetId": "165225828876",
                "newValue": "sportlife.com.br",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_domain",
                "tenantName": "Demo Advertiser",
                "trId": 261,
                "bekiCampId": 1627
            },
            {
                "id": "262",
                "platformName": "Google Ads",
                "adSetId": "166618365098",
                "newValue": "curapelanatureza.com.br",
                "status": "4",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_domain",
                "tenantName": "Demo Advertiser",
                "trId": 262,
                "bekiCampId": 1627
            },
            {
                "id": "263",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "689407562070",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_creatives",
                "tenantName": "Demo Advertiser",
                "trId": 263,
                "bekiCampId": 1549
            },
            {
                "id": "264",
                "platformName": "Google Ads",
                "adSetId": "158945463752",
                "newValue": "689519182927",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_creatives",
                "tenantName": "Demo Advertiser",
                "trId": 264,
                "bekiCampId": 1549
            },
            {
                "id": "394",
                "platformName": "Google Ads",
                "adSetId": "146455659279",
                "age": "25-34",
                "newValue": "0.1",
                "status": "0",
                "campaignInfo": "Website Traffic - Winter Sale",
                "roId": "1581",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_age",
                "tenantName": "Demo Advertiser",
                "trId": 394,
                "bekiCampId": 1943
            },
            {
                "id": "415",
                "platformName": "Google Ads",
                "adSetId": "146455659119",
                "age": "45-54",
                "newValue": "-0.1",
                "status": "0",
                "campaignInfo": "Website Traffic - Winter Sale",
                "roId": "1581",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_age",
                "tenantName": "Demo Advertiser",
                "trId": 415,
                "bekiCampId": 1943
            },
            {
                "id": "417",
                "platformName": "Google Ads",
                "adSetId": "146455659279",
                "age": "25-34",
                "newValue": "0.1",
                "status": "0",
                "campaignInfo": "Website Traffic - Winter Sale",
                "roId": "1581",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_age",
                "tenantName": "Demo Advertiser",
                "trId": 417,
                "bekiCampId": 1943
            },
            {
                "id": "510",
                "platformName": "Google Ads",
                "adSetId": "158945463752",
                "newValue": "0.10",
                "device": "Mobile",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 510,
                "bekiCampId": 1549
            },
            {
                "id": "513",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "Otimização de Site WordPress",
                "status": "0",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 513,
                "bekiCampId": 1552
            },
            {
                "id": "514",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "WP Maintenance mode",
                "status": "3",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 514,
                "bekiCampId": 1552
            },
            {
                "id": "515",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "assessoria wordpress",
                "status": "0",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 515,
                "bekiCampId": 1552
            },
            {
                "id": "520",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "0.10",
                "device": "Tablet",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 520,
                "bekiCampId": 1587
            },
            {
                "id": "524",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "0.10",
                "device": "Desktop",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 524,
                "bekiCampId": 1549
            },
            {
                "id": "525",
                "platformName": "Google Ads",
                "adSetId": "158945463752",
                "newValue": "0.10",
                "device": "Mobile",
                "status": "3",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 525,
                "bekiCampId": 1549
            },
            {
                "id": "528",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "Otimização de Site WordPress",
                "status": "0",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 528,
                "bekiCampId": 1552
            },
            {
                "id": "529",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "WP Maintenance mode",
                "status": "0",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 529,
                "bekiCampId": 1552
            },
            {
                "id": "530",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "assessoria wordpress",
                "status": "0",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 530,
                "bekiCampId": 1552
            },
            {
                "id": "534",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "-0.10",
                "geo": "Brazil,State of Ceara,Maracanau",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 534,
                "bekiCampId": 1587
            },
            {
                "id": "535",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "0.10",
                "device": "Tablet",
                "status": "3",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 535,
                "bekiCampId": 1587
            },
            {
                "id": "536",
                "platformName": "Google Ads",
                "adSetId": "166618365098",
                "newValue": "0.10",
                "geo": "Brazil,State of Sao Paulo,Sao Paulo",
                "status": "3",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 536,
                "bekiCampId": 1627
            },
            {
                "id": "537",
                "platformName": "Google Ads",
                "adSetId": "166618365098",
                "newValue": "0.10",
                "geo": "Brazil,State of Sao Paulo,Barueri",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 537,
                "bekiCampId": 1627
            },
            {
                "id": "538",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "-0.10",
                "geo": "Brazil,State of Maranhao,Caxias",
                "status": "4",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 538,
                "bekiCampId": 1587
            },
            {
                "id": "539",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "0.10",
                "device": "Desktop",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 539,
                "bekiCampId": 1549
            },
            {
                "id": "540",
                "platformName": "Google Ads",
                "adSetId": "158945463752",
                "newValue": "0.10",
                "device": "Mobile",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 540,
                "bekiCampId": 1549
            },
            {
                "id": "541",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "0.10",
                "geo": "Brazil,State of Paraiba,Alagoa Grande",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 541,
                "bekiCampId": 1549
            },
            {
                "id": "542",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "-0.10",
                "geo": "Brazil,State of Rio Grande do Norte,Mossoro",
                "status": "3",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 542,
                "bekiCampId": 1587
            },
            {
                "id": "543",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "Otimização de Site WordPress",
                "status": "4",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 543,
                "bekiCampId": 1552
            },
            {
                "id": "544",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "WP Maintenance mode",
                "status": "0",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 544,
                "bekiCampId": 1552
            },
            {
                "id": "545",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "assessoria wordpress",
                "status": "3",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 545,
                "bekiCampId": 1552
            },
            {
                "id": "546",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "0.10",
                "geo": "Brazil,State of Goias,Aguas Lindas de Goias",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 546,
                "bekiCampId": 1549
            },
            {
                "id": "547",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "0.10",
                "geo": "Brazil,State of Para,Ananindeua",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 547,
                "bekiCampId": 1549
            },
            {
                "id": "548",
                "platformName": "Google Ads",
                "adSetId": "166618365098",
                "newValue": "0.10",
                "geo": "Brazil,State of Sao Paulo,Atibaia",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 548,
                "bekiCampId": 1627
            },
            {
                "id": "549",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "-0.10",
                "geo": "Brazil,State of Ceara,Maracanau",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 549,
                "bekiCampId": 1587
            },
            {
                "id": "550",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "0.10",
                "device": "Tablet",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 550,
                "bekiCampId": 1587
            },
            {
                "id": "551",
                "platformName": "Google Ads",
                "adSetId": "166618365098",
                "newValue": "0.10",
                "geo": "Brazil,State of Sao Paulo,Sao Paulo",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 551,
                "bekiCampId": 1627
            },
            {
                "id": "552",
                "platformName": "Google Ads",
                "adSetId": "166618365098",
                "newValue": "0.10",
                "geo": "Brazil,State of Sao Paulo,Barueri",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 552,
                "bekiCampId": 1627
            },
            {
                "id": "553",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "-0.10",
                "geo": "Brazil,State of Maranhao,Caxias",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 553,
                "bekiCampId": 1587
            },
            {
                "id": "554",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "0.10",
                "device": "Desktop",
                "status": "4",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 554,
                "bekiCampId": 1549
            },
            {
                "id": "555",
                "platformName": "Google Ads",
                "adSetId": "158945463752",
                "newValue": "0.10",
                "device": "Mobile",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 555,
                "bekiCampId": 1549
            },
            {
                "id": "556",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "0.10",
                "geo": "Brazil,State of Paraiba,Alagoa Grande",
                "status": "4",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 556,
                "bekiCampId": 1549
            },
            {
                "id": "557",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "-0.10",
                "geo": "Brazil,State of Rio Grande do Norte,Mossoro",
                "status": "0",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 557,
                "bekiCampId": 1587
            },
            {
                "id": "560",
                "platformName": "Meta",
                "adSetId": "120208683901390374",
                "currentValue": "250",
                "newValue": "200",
                "status": "0",
                "campaignInfo": "Customer Engagement - Holiday Campaign",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Whitelisting_age",
                "tenantName": "Demo Advertiser",
                "trId": 560,
                "bekiCampId": 1543
            },
            {
                "id": "561",
                "platformName": "Meta",
                "adSetId": "120208683901465565",
                "currentValue": "150",
                "newValue": "200",
                "status": "0",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Whitelisting_age",
                "tenantName": "Demo Advertiser",
                "trId": 561,
                "bekiCampId": 1549
            },
            {
                "id": "562",
                "platformName": "Google Ads",
                "adSetId": "120208683901465565",
                "newValue": "genAI",
                "status": "3",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Generative AI_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 562,
                "bekiCampId": 1549
            },
            {
                "id": "563",
                "platformName": "Google Ads",
                "adSetId": "120208683901390374",
                "newValue": "openAI",
                "status": "0",
                "campaignInfo": "Customer Engagement - Holiday Campaign",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Generative AI_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 563,
                "bekiCampId": 1543
            }
        ],
        "filter": {
            "advertisers": [
                {
                    "id": 1,
                    "value": "Demo Advertiser"
                }
            ],
            "platforms": [
                {
                    "id": 2,
                    "value": "Meta"
                },
                {
                    "id": 3,
                    "value": "Google Ads"
                }
            ],
            "campaigns": [
                {
                    "id": 4,
                    "value": "Customer Engagement - Holiday Campaign"
                },
                {
                    "id": 5,
                    "value": "Brand Awareness - Festive Teaser"
                },
                {
                    "id": 6,
                    "value": "Website Traffic - Winter Sale"
                },
                {
                    "id": 7,
                    "value": "Audience Awareness - New Year Teaser"
                },
                {
                    "id": 8,
                    "value": "Truview Skippable - Product Launch"
                },
                {
                    "id": 9,
                    "value": "Reach Skippable - Seasonal Offer"
                },
            ],
            "recoTypes": [
                "Bid Control_geo",
                "Bid Control_age",
                "Whitelisting_age",
                "Whitelisting_gender",
                "Blacklisting_creatives",
                "Blacklisting_keyword",
                "Blacklisting_domain",
                "Whitelisting_devices",
                "Bid Control_devices",
                "Generative AI_keyword"
            ],
            "status": [
                {
                    "id": "4",
                    "value": "Execution Failed"
                },
                {
                    "id": "2",
                    "value": "Rejected"
                },
                {
                    "id": "3",
                    "value": "Execution Success"
                },
                {
                    "id": "0",
                    "value": "No Action"
                }
            ]
        }
    }
}

export const executedRecommendationList = {
    "responseCode": {
        "code": 102,
        "status": "Success",
        "desc": "Recommendation History List Fetched Successfully"
    },
    "responseList": {
        "recommendationList": [
            {
                "id": "51",
                "platformName": "Meta",
                "adSetId": "120207754459090374",
                "newValue": "mobile_app",
                "status": "3",
                "campaignInfo": "Customer Engagement - Holiday Campaign",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Whitelisting_devices",
                "tenantName": "Demo Advertiser",
                "trId": 51,
                "bekiCampId": 1543,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "262",
                "platformName": "Google Ads",
                "adSetId": "166618365098",
                "newValue": "curapelanatureza.com.br",
                "status": "4",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_domain",
                "tenantName": "Demo Advertiser",
                "trId": 262,
                "bekiCampId": 1627,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "514",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "WP Maintenance mode",
                "status": "3",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 514,
                "bekiCampId": 1552,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "525",
                "platformName": "Google Ads",
                "adSetId": "158945463752",
                "newValue": "0.10",
                "device": "Mobile",
                "status": "3",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 525,
                "bekiCampId": 1549,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "535",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "0.10",
                "device": "Tablet",
                "status": "3",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 535,
                "bekiCampId": 1587,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "536",
                "platformName": "Google Ads",
                "adSetId": "166618365098",
                "newValue": "0.10",
                "geo": "Brazil,State of Sao Paulo,Sao Paulo",
                "status": "3",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1268",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 536,
                "bekiCampId": 1627,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "538",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "-0.10",
                "geo": "Brazil,State of Maranhao,Caxias",
                "status": "4",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 538,
                "bekiCampId": 1587,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "542",
                "platformName": "Google Ads",
                "adSetId": "167884722609",
                "newValue": "-0.10",
                "geo": "Brazil,State of Rio Grande do Norte,Mossoro",
                "status": "3",
                "campaignInfo": "Brand Awareness - Festive Teaser",
                "roId": "1243",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 542,
                "bekiCampId": 1587,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "543",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "Otimização de Site WordPress",
                "status": "4",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 543,
                "bekiCampId": 1552,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "545",
                "platformName": "Google Ads",
                "adSetId": "163761217403",
                "newValue": "assessoria wordpress",
                "status": "3",
                "campaignInfo": "Audience Awareness - New Year Teaser",
                "roId": "1214",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Blacklisting_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 545,
                "bekiCampId": 1552,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "554",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "0.10",
                "device": "Desktop",
                "status": "4",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_devices",
                "tenantName": "Demo Advertiser",
                "trId": 554,
                "bekiCampId": 1549,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "556",
                "platformName": "Google Ads",
                "adSetId": "156002202903",
                "newValue": "0.10",
                "geo": "Brazil,State of Paraiba,Alagoa Grande",
                "status": "4",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1211",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Bid Control_geo",
                "tenantName": "Demo Advertiser",
                "trId": 556,
                "bekiCampId": 1549,
                "executedDate": "2025-01-15 05:16:20"
            },
            {
                "id": "562",
                "platformName": "Google Ads",
                "adSetId": "120208683901465565",
                "newValue": "genAI",
                "status": "3",
                "campaignInfo": "Reach Skippable - Seasonal Offer",
                "roId": "1204",
                "createdOn": "2024-12-25 05:16:20",
                "recoType": "Generative AI_keyword",
                "tenantName": "Demo Advertiser",
                "trId": 562,
                "bekiCampId": 1549,
                "executedDate": "2025-01-15 05:16:20"
            }
        ],
        "filter": {
            "advertisers": [
                {
                    "id": 1,
                    "value": "Demo Advertiser"
                }
            ],
            "platforms": [
                {
                    "id": 2,
                    "value": "Meta"
                },
                {
                    "id": 3,
                    "value": "Google Ads"
                }
            ],
            "campaigns": [
                {
                    "id": 4,
                    "value": "Customer Engagement - Holiday Campaign"
                },
                {
                    "id": 5,
                    "value": "Brand Awareness - Festive Teaser"
                },
                {
                    "id": 6,
                    "value": "Website Traffic - Winter Sale"
                },
                {
                    "id": 7,
                    "value": "Audience Awareness - New Year Teaser"
                },
                {
                    "id": 8,
                    "value": "Truview Skippable - Product Launch"
                },
                {
                    "id": 9,
                    "value": "Reach Skippable - Seasonal Offer"
                },
            ],
            "recoTypes": [
                "Bid Control_geo",
                "Bid Control_age",
                "Whitelisting_age",
                "Whitelisting_gender",
                "Blacklisting_creatives",
                "Blacklisting_keyword",
                "Blacklisting_domain",
                "Whitelisting_devices",
                "Bid Control_devices",
                "Generative AI_keyword"
            ],
            "status": [
                {
                    "id": "4",
                    "value": "Execution Failed"
                },
                {
                    "id": "2",
                    "value": "Rejected"
                },
                {
                    "id": "3",
                    "value": "Execution Success"
                },
                {
                    "id": "0",
                    "value": "No Action"
                }
            ]
        }
    },

}
